import React from "react";
import LegalPage from "./LegalPage";
import data from "@content/legal/refund.json";

const RefundPolicy = () => (
    <LegalPage slug="refund-policy" data={data} crumbLabel="Refund Policy" />
);

export default RefundPolicy;
